import React from 'react';
import PropTypes from 'prop-types';
import DataProvider from 'api/data-provider';
import map from 'lodash/map';
import Bem from 'bemHelper';
import Row, { Col } from 'components/row';

import ComplaintsButtonChecked from './complaints-button-checked';
import CardInfo from '../card-info';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const bemClassesPostControl = new Bem('postControlForum');
const bemClassesPostsUserInfo = new Bem('postUserInfo');

export default class ComplaintsContentGetOther extends React.PureComponent {
  static propTypes = {
    postId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])
  };

  static showOtherComplaintsData(val = {}) {
    const data = val.data || {};
    if (!data || !data.length) return null;

    return (
      <div {...bemClassesPostControl('complaints')}>
        <div>
          <span {...bemClassesPostControl('text', 'bold')}>Жалобы на пост:</span>
        </div>
        {map(data, (item, index) => (
          <div key={`complain-other-${index}`}>
            {item.user_id && item.forum_nick &&
              <span {...bemClassesPostsUserInfo('nick')}>
                <CardInfo
                  {...bemClassesPostsUserInfo('cardInfo')}
                  // userPhoto={comment.image}
                  userPhoto={{ id: item.avatar }}
                  userName={item.forum_nick}
                  userId={item.user_id}
                />
                <span {...bemClassesPostControl('text')}>&nbsp;({item.user_count_complaints}):&ensp;</span>
              </span>
            }
            <span {...bemClassesPostControl('text')}>
              {item.title} {item.user_desc && `(${item.user_desc})`}
            </span>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { postId } = this.props;

    return (
      <React.Fragment>
        <Row>
          <Col allAuto allPr={0}>
            <div {...bemClassesPostControl('leftCol')} />
          </Col>
          <Col allPr={0}>
            <div {...bemClassesPostControl('separate')} />
          </Col>
        </Row>
        <Row {...bemClassesPostControl('main', 'complaints')}>
          <Col allPt={15} allPb={15} allPl={16} allPr={16}>
            <DataProvider
              url="admin/complaints/complaints"
              query={{
                'entity-id': postId,
                getAll: true
              }}
              renderer={ComplaintsContentGetOther.showOtherComplaintsData}
            />
          </Col>
          <Col allAuto allPr={9}>
            <ComplaintsButtonChecked postId={postId} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
